module.exports = __webpack_public_path__ + "static/media/ssr7dc29e7c7bfcde81adddf441d981d4f5.webp";